module.exports = __webpack_public_path__ + "img/PG.8d90cd4c.png";